import React from 'react';
import { Button, Typography, Result, Row, Col } from 'antd';
import { LoginOutlined } from '@ant-design/icons';

const SignOutPage = ({ onLogin, isLoading }) => {
  return (
    <Row justify="center" align="middle" style={{ minHeight: '70vh' }}>
      <Col>
        <Result
          status="success"
          title="Successfully Signed Out"
          subTitle="You have been successfully signed out from all services."
          extra={[
            <Button 
              type="primary" 
              key="login" 
              size="large"
              onClick={onLogin}
              loading={isLoading}
              disabled={isLoading}
              icon={<LoginOutlined />}
            >
              Sign In Again
            </Button>
          ]}
        />
        <Typography.Text style={{ display: 'block', textAlign: 'center', marginTop: '20px' }}>
          Your session has been terminated. To access the platform again, please sign in.
        </Typography.Text>
      </Col>
    </Row>
  );
};

export default SignOutPage; 